import { LoadingPage } from "./component";
export default LoadingPage;
